import { render } from "./Section5.vue?vue&type=template&id=48cddcae&scoped=true"
import script from "./Section5.vue?vue&type=script&lang=js"
export * from "./Section5.vue?vue&type=script&lang=js"

import "./Section5.vue?vue&type=style&index=0&id=48cddcae&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48cddcae"]])

export default __exports__